import React from "react";
import "./StatusMessage.css";

const StatusMessage = ({
  message,
  type = "info", // "success", "error", "info", "warning"
  show = true,
  onClose = null,
  autoClose = false,
  autoCloseDelay = 5000,
}) => {
  const [isVisible, setIsVisible] = React.useState(show);

  React.useEffect(() => {
    setIsVisible(show);
  }, [show]);

  React.useEffect(() => {
    if (autoClose && isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [autoClose, isVisible, autoCloseDelay, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible || !message) {
    return null;
  }

  return (
    <div className={`status-message status-message--${type}`}>
      <div className="status-message__content">
        <div className="status-message__icon">
          {type === "success" && <span className="icon-check">✓</span>}
          {type === "error" && <span className="icon-error">✕</span>}
          {type === "warning" && <span className="icon-warning">⚠</span>}
          {type === "info" && <span className="icon-info">ℹ</span>}
        </div>
        <div className="status-message__text">{message}</div>
        {onClose && (
          <button
            className="status-message__close"
            onClick={handleClose}
            aria-label="Close message"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default StatusMessage;
